import { v4 as UUID } from 'uuid';

export default class Snackbar {
  constructor(snackbar) {
    Object.assign(this, this.createSnackbar(snackbar));
  }

  createSnackbar(snackbar) {
    return {
      id: UUID(),
      type: snackbar.type || Snackbar.TYPE.SUCCESS,
      message: {
        text: snackbar.message.text,
        i18nKey: snackbar.message.i18nKey,
        params: snackbar.message.params || null
      },
      timeout: snackbar.timeout || 5000,
      dismissible: snackbar.dismissible || false
    };
  }

  static get TYPE() {
    return {
      ERROR: 'error',
      WARNING: 'warning',
      SUCCESS: 'success',
      INFO: 'info'
    };
  }
}
